import { createSelector } from "reselect";
import { cloneDeep, get } from "lodash";
import { getAtIdFromMatchProps } from "../selectorUtils.js";

import { AT_TYPES } from "../../../constants/entity.js";
import { RESOURCE_URI_CHUNKS } from "../../../constants/entity.js";

import operationSelector from "../operations/operationSelector.js";

// -- STATE QUERIES -- //

const entitiesDataMapQuery = state =>
  get(state, "ephemeralEntities.dataMap", null);

const userFromMatchPropsQuery = (state, props, id) => {
  const entities = entitiesDataMapQuery(state, props);
  if (!entities) return null;

  const userId = id
    ? id
    : getAtIdFromMatchProps(props, RESOURCE_URI_CHUNKS.USERS);

  return entities[userId];
};

const ephemeralUsersQuery = state => {
  const dataMap = state.ephemeralEntities.dataMap;
  const dataIndex = state.ephemeralEntities.dataIndex;

  const userGroupsIndex = dataIndex.filter(atId => {
    const userGroup = dataMap[atId];
    return userGroup["@type"] === AT_TYPES.USER;
  });

  return userGroupsIndex.map(atId => dataMap[atId]);
};

const ephemeralUserGroupsQuery = state => {
  const dataMap = state.ephemeralEntities.dataMap;
  const dataIndex = state.ephemeralEntities.dataIndex;

  const userGroupsIndex = dataIndex.filter(atId => {
    const userGroup = dataMap[atId];
    return userGroup["@type"] === AT_TYPES.USER_GROUP;
  });

  return userGroupsIndex.map(atId => dataMap[atId]);
};

// -- SELECTORS -- //

const selectUser = createSelector(
  [userFromMatchPropsQuery, operationSelector.permissionsQuery],
  (baseUser, permissions) => {
    if (!baseUser) return null;

    const user = cloneDeep(baseUser);

    return operationSelector.stampOperationPermissions(user, permissions);
  }
);

const selectUsers = createSelector(
  [ephemeralUsersQuery, operationSelector.permissionsQuery],
  (ephemeralUsers, permissions) => {
    if (!ephemeralUsers) return [];

    const users = ephemeralUsers.map(user => {
      const userClone = cloneDeep(user);
      return userClone;
    });

    return operationSelector.stampOperationPermissions(users, permissions);
  }
);

const selectUserGroups = createSelector(
  [ephemeralUserGroupsQuery, operationSelector.permissionsQuery],
  (ephemeralUserGroups, permissions) => {
    if (!ephemeralUserGroups) return [];

    const users = ephemeralUserGroups.map(userGroup => {
      const userGroupClone = cloneDeep(userGroup);
      return userGroupClone;
    });

    return operationSelector.stampOperationPermissions(users, permissions);
  }
);

// using the following export pattern so we can mock more easily using jest

const userSelector = {
  selectUser,
  selectUsers,
  selectUserGroups
};

export default userSelector;
